import { useContext, createContext, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import selectors from "selectors";
import Translations from "translations";
export const LanguageContext = createContext();
export let languageRef = (key) => key;

export const LanguageProvider = ({ children }) => {
  const language = useSelector(selectors.getSpeaksSpanish)
    ? "spanish"
    : "english";
  const translate = useCallback(
    key => {
      try {
        return Translations[key][language];
      } catch (e) {
        console.log(`Could not find translation for ${key}`);
        return key;
      }
    },
    [language]
  );
  useEffect(() => {
    languageRef = translate;
  }, [translate]);
  return (
    <LanguageContext.Provider value={{ translate: translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = { children: PropTypes.node };

const useTranslate = () => {
  const { translate } = useContext(LanguageContext);
  return translate;
};

export default useTranslate;
